function PassengerReviewPageHandler(product = '', event = '', data = {}) {
    const { metaData = {}, hInfo = {}, panRequired, searchQuery = {}, ris = [], omi = {}  } = data,
        { ss = '' } = omi,
        { sn = '', uid = '' } = hInfo,
        { searchId = '', searchCriteria = {} } = searchQuery,
        { cityName = '' } = searchCriteria,
        [room = {}] = ris,
        { tafcs = {} } = room,
        { TAF = {} } = tafcs,
        { SGP = 0, SNP = 0, SAC = 0 } = TAF,
        { userId } = metaData;

    let finalData = {
        Identity: userId, product: product, searchId: searchId, unicaId: uid, location: cityName, panRequired,
        supplier: ss, gross: SGP, net: SNP, commission: SAC
    }
    switch (event) {
        case 'PageView':
            break;
        case 'ProceedToPay':
            break;
        case 'Block':
            break;
    }
    return finalData;
}

module.exports = { PassengerReviewPageHandler }